import { defineTool } from '../../canvas/tooling/ToolDefinition';
import { InstantDequipBehavior } from '../objectLibrary/ObjectTool';

export const gadgetTool = defineTool({
    id: 'gadgets',
    label: 'Gadgets',
    category: 'design',
    icon: 'deqo://icons/d2/gadget',
    weight: 3045,
    behaviors: [
        InstantDequipBehavior,
    ]
});
